import { TellescopeModelFromName, useTellescopeQueries } from "@tellescope/tanstack-query";

export interface UseFilesFromSecureNamesResult {
  files: TellescopeModelFromName<"files">[];
  isLoading: boolean;
  isError: boolean;
  loadingCount: number;
}

export const useFilesFromSecureNames = <T extends { secureName: string } | string>(
  items: T[]
): UseFilesFromSecureNamesResult =>
  useTellescopeQueries({
    model: "files",
    method: "getOne",
    requests: items.map((item): { secureName: string } => ({
      secureName: typeof item === "string" ? item : item.secureName,
    })),
    enabled: !!items.length,
    combine: (queries) =>
      queries.reduce<UseFilesFromSecureNamesResult>(
        (acc, curr) => {
          acc.isLoading = acc.isLoading || curr.isLoading;
          acc.isError = acc.isError || curr.isError;
          if (curr.data) {
            acc.files.push(curr.data);
            acc.loadingCount -= 1;
          }
          return acc;
        },
        { isLoading: false, isError: false, files: [], loadingCount: items.length }
      ),
  });
